var ManufacturingLayerTypes = {
    COPPER : "COPPER",
    SOLDERMASK : "SOLDERMASK",
    SOLDERPASTE : "SOLDERPASTE",
    GLUE : "GLUE",
    DRILL : "DRILL",
    SILKSCREEN : "SILKSCREEN",
    RESTRICT : "RESTRICT",
    ASSEMBLY: "ASSEMBLY"
};
module.exports = ManufacturingLayerTypes;

